<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">{{ icon }}</mat-icon>
    <span class="section-title">{{ titleString }}</span>
    <button mat-icon-button class="close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content class="dialog-content">
    <app-resources-ai [mediaTypeFilter]="mediaTypeFilter"></app-resources-ai>
</div>